define(function(require, exports, module) {
    'use strict';

    const CommonLookupView = require('common/addressLookupSwiss/lookupControls/commonLookupView');
    const ZipCityProvider = require('common/addressLookupSwiss/sourceProviders/zipCityProvider');

    module.exports = CommonLookupView.extend({
        controlType: 'zipCity',

        SourceProvider: ZipCityProvider
    });

});
